import React from "react";
import {Input, Button, Tooltip, Table, DatePicker, Select, TimePicker, Popconfirm, Radio, Divider} from "antd";
import './index.sass';
import locale from 'antd/es/date-picker/locale/zh_CN';
import {SearchOutlined, ToTopOutlined} from '@ant-design/icons';
import api from "../../utils/api";
import qs from "../../utils/qs";
import {Base64} from "js-base64";

const {RangePicker} = DatePicker;
const {Option} = Select;


export default class Finance extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            balance_info: {},
            dataSource: [],
            order_id: '',//订单编号
            settled_at: '',//结算时间
            is_in: '',//资金流向
            trade_type: '',//交易类型
            receiver_account_type: '',//收款账户类型
            amount: [0, 0],//金额
            search: ''
        }
    }

    componentDidMount () {
        this.getBalanceRecord();
    }

    getBalanceRecord = async (search = '') => {//账户资产明细//列表
        let param = {
            type: 1
        }
        if (search) {
            param['search'] = search
        }
        let res = await api('get-balance-records', param)//资产明细列表
        let ress = await api('balance-info')//资产明细
        if (ress.code === 200) {
            this.setState({
                balance_info: ress.data
            })
        }

        if (res.code === 200) {
            this.setState({
                dataSource: res.data
            })
        }

    }


    searchRule = () => {

        let {order_id, trade_type, is_in, settled_at, receiver_account_type, amount} = this.state;

        let sqlarr = [
            {name: 'order_id', val: order_id, rule: "like"},
            {name: 'trade_type', val: trade_type, rule: "="},
            {name: 'is_in', val: is_in, rule: "="},
            {name: 'settled_at', val: settled_at, rule: "between"},
            {name: 'amount', val: amount, rule: "between"},
            {name: 'receiver_account_type', val: receiver_account_type, rule: "="},
        ]

        let sql = qs.sqlSearch(sqlarr);

        let {search} = sql;

        search = Base64.encode(JSON.stringify(search));

        this.getBalanceRecord(search)

    }


    render () {

        let {balance_info, dataSource} = this.state;

        const columns = [
            {
                title: '入账/出账时间',
                dataIndex: 'settled_at',
                key: 'settled_at',
            },
            {
                title: '关联活动',
                dataIndex: 'detail',
                key: 'detail',
            },
            {
                title: '关联订单/交易编号',
                dataIndex: 'trade_no',
                key: 'trade_no',
            },
            {
                title: '入账/出账金额',
                dataIndex: 'amount',
                key: 'amount',
            },
            {
                title: '类型',
                dataIndex: 'trade_type',
                key: 'trade_type',
            },
            {
                title: '交易账户',
                dataIndex: 'out_order_id',
                key: 'out_order_id',
            },
            {
                title: '状态',
                dataIndex: 'tip',
                key: 'tip',
            },
        ];

        return (
            <div className='finance'>
                <div className='record'>
                    <div className='change_fans flex'>

                        <div className='flex line alignCenter mgr40'>
                            订单编号：
                            <Input placeholder='订单编号：' onChange={(e) => {
                                this.setState({order_id: e.target.value})
                            }}/>
                        </div>

                        <div className='flex line alignCenter mgr40'>
                            日期选择：
                            <RangePicker locale={locale} onChange={(e, d) => {
                                this.setState({settled_at: d})
                            }}/>
                        </div>

                        <div className='flex line alignCenter mgr40'>
                            资金流向：
                            <Select
                                className='width140'
                                placeholder="全部"
                                optionFilterProp="children"
                                onChange={(e) => {
                                    this.setState({is_in: e})
                                }}

                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="">全部</Option>
                                <Option value="2">收入</Option>
                                <Option value="3">支出</Option>
                            </Select>
                        </div>

                        <div className='flex line alignCenter mgr40'>
                            账务类型：
                            <Select
                                className='width140'
                                placeholder="全部"
                                optionFilterProp="children"
                                onChange={(e) => {
                                    this.setState({trade_type: e})
                                }}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="">全部</Option>
                                <Option value="1">交易收入</Option>
                                <Option value="2">帮卖佣金</Option>
                                <Option value="32">充值</Option>
                                <Option value="8">退款补帮卖佣金</Option>
                                <Option value="16">提现</Option>
                                <Option value="4">售后退款</Option>
                                <Option value="0">其他</Option>

                                {/* <Option value="lucy">分账支付佣金</Option>
                                <Option value="tom">技术服务费</Option> */}
                            </Select>
                        </div>

                        <div className='flex line alignCenter mgr40'>
                            账户类型：
                            <Select
                                className='width140'
                                placeholder="全部"
                                optionFilterProp="children"
                                onChange={(e) => {
                                    this.setState({receiver_account_type: e})
                                }}

                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="">全部</Option>
                                <Option value="32">微信商户账户</Option>
                                <Option value="16">磁力圈商户账户</Option>
                                <Option value="0">微信钱包</Option>
                            </Select>
                        </div>


                        <div className='flex line alignCenter mgr40'>
                            金额：
                            <Input onChange={(e) => {
                                let {amount} = this.state;
                                amount[0] = e.target.value
                                this.setState({
                                    amount
                                })
                            }} className='width140' placeholder='最低价格'/> ~ <Input onChange={(e) => {
                            let {amount} = this.state;
                            amount[1] = e.target.value
                            this.setState({
                                amount
                            })
                        }} className='width140' placeholder='最高价格'/>
                        </div>

                        <Button onClick={() => {
                            this.searchRule()
                        }} className='mgr10 themeBtn' icon={<SearchOutlined/>}>搜索</Button>

                        <Button className='mgr10'>重置</Button>

                    </div>


                    <div className='user_right pdtb20 mgb10'>

                        <ul className='flex census'>
                            <li className='pdrl80'>
                                <label>收入金额</label>
                                <p>￥{Math.floor((balance_info.incoming === undefined ? 0 : balance_info.incoming) * 100) / 100}</p>
                            </li>
                            <li className='pdrl80'>
                                <label>收入笔数（笔）</label>
                                <p>{balance_info.incoming_record_num}</p>
                            </li>
                            <li className='pdrl80'>
                                <label>支出金额</label>
                                <p>￥{Math.floor((balance_info.outcoming === undefined ? 0 : balance_info.outcoming) * 100) / 100}</p>
                            </li>
                            <li className='pdrl80'>
                                <label>支出笔数（笔）</label>
                                <p>{balance_info.outcoming_record_num}</p>
                            </li>
                        </ul>

                    </div>


                    <div className='change_fans'>
                        <Button icon={<ToTopOutlined/>} className='themeBtn mgb10' size='' onClick={() => {
                            this.show_export_handle()
                        }}>批量导出订单</Button>
                        <Table dataSource={dataSource} columns={columns}/>
                    </div>

                </div>
            </div>
        )
    }

}